<div [ngClass]="!mode ? 'example-wrapper' : 'outer-example-wrapper'">
  <div class="gift-note-example">
    <div class="gift-note-example-header">
      <pdq-checkbox [disabled]="true" [checked]="true"></pdq-checkbox>
      <label>{{ template?.giftMessage?.checkboxText }}</label>
    </div>
    <div class="gift-note-content">
      <input type="text" [value]="template?.giftMessage?.inputPlaceholder" class="gift-note-input" disabled />
      @if (template?.collectEmail?.active) {
        <input type="text" [value]="template?.collectEmail?.inputPlaceholder" class="gift-note-input" disabled />
      }
    </div>
  </div>
</div>
